import React from "react";
import { FileIcon } from "lucide-react";

interface EmptyStateProps {
    icon?: React.ReactNode;
    title: string;
    description: string | React.ReactNode;
    action?: React.ReactNode;
}

export function EmptyState({
    icon = <FileIcon className="h-12 w-12 text-gray-300 dark:text-gray-600" />,
    title,
    description,
    action,
}: EmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
            <div className="mb-4 rounded-full bg-gray-100 dark:bg-gray-800 p-4">
                {icon}
            </div>
            <h3 className="mb-2 text-lg font-medium text-gray-900 dark:text-gray-100">
                {title}
            </h3>
            <p className="mb-6 max-w-lg text-gray-500 dark:text-gray-400">
                {description}
            </p>
            {action && <div>{action}</div>}
        </div>
    );
}
